export var CursorStatus;
(function (CursorStatus) {
    CursorStatus["Empty"] = "empty";
    CursorStatus["Slash"] = "slash";
})(CursorStatus || (CursorStatus = {}));
const createStatusCtx = () => {
    return {
        cursorStatus: CursorStatus.Empty,
        filter: '',
        activeActions: [],
    };
};
const clearStatus = (status) => {
    status.cursorStatus = CursorStatus.Empty;
    status.filter = '';
};
const setSlash = (status, filter = '') => {
    status.cursorStatus = CursorStatus.Slash;
    status.filter = filter;
};
export const createStatus = () => {
    const statusCtx = createStatusCtx();
    return {
        clearStatus: () => clearStatus(statusCtx),
        setSlash: (filter = '') => setSlash(statusCtx, filter),
        setActions: (actions) => {
            statusCtx.activeActions = actions;
        },
        get: () => statusCtx,
        isEmpty: () => statusCtx.cursorStatus === CursorStatus.Empty,
        isSlash: () => statusCtx.cursorStatus === CursorStatus.Slash,
    };
};
//# sourceMappingURL=status.js.map